module.exports = __webpack_public_path__ + "static/media/26.40b6052f.mp3";